<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      返佣查询
    </p>
    <div class="balance" style="margin:10px 0">
      <span style="margin-right:100px">订单数：{{balanceDetail.orderNum}}</span>
      <span>返佣金额：{{balanceDetail.balance_price}}元</span>
    </div>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
   </card>
 </div>
</template>

<script>
import {mapState} from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'

export default {
  components: {
    DateRangePicker
  },
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      balanceDetail: {},
      emptyORderTime: ['', ''],
      emptyOpenTime: ['', ''],
      palyName: '',
      busType: '',
      buyPeople: '',
      corpid: '',
      BUYButton: 0,
      editModal: false, // 购买弹窗
      planId: 1,
      editTitle: '购买',
      type: 1,
      editReportCurstom: false, // 报备客户
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: []
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'OrderDetail', params: { orderId: row.id } })
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['查看'])
            return h('span', [
              check
            ])
          }
        },
        {
          title: '订单号',
          key: 'order_no',
          width: 180,
          ellipsis: true
        },
        {
          title: '订单类型',
          key: 'ep_name',
          width: 120,
          render: (h, {row}) => {
            let buy = ''
            if (row.type === 1) {
              buy = '购买'
            } else if (row.type === 2) {
              buy = '升级'
            } else if (row.type === 3) {
              buy = '续费'
            }
            return ('span', [buy])
          }
        },
        {
          title: '订单内容',
          width: 140,
          render: (h, {row}) => {
            let Year = row.use_year_type
            for (var item of this.buyPeople) {
              if (item.value === row.fk_t_charge_package_id) {
                if (row.type === 2) {
                  if (row.fk_t_charge_package_id === 8) {
                    return h('span', ['不限工号'])
                  } else {
                    return h('span', [item.maxNum + '用户'])
                  }
                } else {
                  if (row.fk_t_charge_package_id === 8) {
                    return h('span', ['不限工号' + Year + '年'])
                  } else {
                    return h('span', [item.maxNum + '用户' + Year + '年'])
                  }
                }
              }
            }
          }
        },
        {
          title: '是否为特殊订单',
          key: 'create_time',
          width: 140,
          render: (h, {row}) => {
            let specialOrder = ''
            if (row.is_special === 1) {
              specialOrder = '是'
            } else {
              specialOrder = '-'
            }
            return h('span', [specialOrder])
          }
        },
        {
          title: '开通时间',
          key: 'inception_start_time',
          width: 180
        },
        {
          title: '代理付款金额',
          key: 'agent_pay_price',
          width: 140
        },
        {
          title: '代理成交金额',
          key: 'special_agent_price',
          width: 140
        },
        {
          title: '代理返佣金额',
          key: 'return_price',
          width: 140
        },
        {
          title: '企业名称',
          key: 'ep_name',
          width: 140
        },
        {
          title: 'CropID',
          key: 'corpid',
          width: 140
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get(`/balance/info/${this.orderId}`),
        this.$http.get(`/balance/order/list/${this.orderId}`)
      ]).then(this.$http.spread((res1, res2) => {
        this.balanceDetail = res1.data
        this.list = res2.data
        this.listLoading = false
      }))
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeChange (daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0].replace('/', '-').replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyORderTime = [this.searchForm[start], this.searchForm[end]]
      this.emptyOpenTime = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm () {
      this.emptyORderTime = ['', '']
      this.emptyOpenTime = ['', '']
      this.searchForm = {
        order_no: '',
        ep_name: '',
        corpid: '',
        order_start_time: '',
        order_end_time: '',
        inception_start_time: '',
        inception_end_time: '',
        type: '',
        order_state: ''
      }
      this.loadList()
    },
    editReport () {
      this.editReportCurstom = true
    }
  },
  created () {
    this.$http.get('/dropdown/industry').then(res => {
      this.busType = res.data
    })
    this.$http.get('/dropdown/chargePackage').then(res => {
      this.buyPeople = res.data
    })
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/handle/balanceHandle/CheckDetail.vue